import instance from "../axios";

export const getAll = async (filters = {}) => {
  try {
    const response = await instance.get("stores", { params: filters });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const getStoreDetails = async (id) => {
  const response = await instance.get(`stores/details/` + id);
  return response.data;
};
export const getStoreVisitations = async (id) => {
  const response = await instance.get(`stores/details/${id}/visitations`);
  return response.data;
};
export const getStoreStockHistory = async () => {
  const response = await instance.get(`stores`);
  return response.data;
};
export const getForPO = async () => {
  const response = await instance.get(`stores/getForPO`);
  return response.data;
};
export const insert = async (data) => {
  const response = await instance.post(`stores`, data);
  return response;
};
export const update = async (data) => {
  const response = await instance.put(`stores`, data);
  return response;
};
export const remove = async (id) => {
  const response = await instance.get(`stores/remove/` + id);
  return response;
};

export const getUplines = async () => {
  const response = await instance.get(`stores/get-uplines`);
  return response.data;
}

export const getStockList = async (id) => {
  const response = await instance.get(`stores/${id}/stocks`);
  return response.data;
}